/* eslint-disable global-require */
module.exports = ['marketplace.searchbars.classifieds.bar.m10', 'marketplace.searchbars.classifieds.bar.m11'];
